(function() {
    'use strict';

    angular.module('blocks.validation', ['ngMessages']);
})();
